module.exports = __webpack_public_path__ + "img/logo_virtualio.143aa6e3.png";